import { createStore, createCollectionStore } from 'aeria-ui'

export const funnel = createStore((context) => {
  const state = reactive({
    modal: false,
    newMessageModal: false,
  })

  return createCollectionStore(
    {
      $id: 'funnel',
      state,
      actions: (state) => ({
        openModal() {
          state.modal = true
        },
        closeModal() {
          state.modal = false
        },
      }),
    },
    context,
  )
})
